import parsePhoneNumber, { PhoneNumber, CountryCode } from 'libphonenumber-js';

export const formatPhoneNumber = (
  phone_number: string,
  country_code: string = 'US',
): string => {
  if (!phone_number) {
    return '';
  }
  /* Default is set to US, but it will detect the country code if
    it's included in the phone number and override the default */
  const phoneNumber: PhoneNumber | undefined = parsePhoneNumber(
    phone_number,
    country_code as CountryCode,
  );
  return phoneNumber ? phoneNumber.formatNational() : phone_number;
};
